/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_PullInputs */

const cs_messages_pull = /** @type {(inputs: Messages_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout ze Sreality`)
};

const en_messages_pull = /** @type {(inputs: Messages_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pull from Sreality`)
};

/**
* | output |
* | --- |
* | "Pull from Sreality" |
*
* @param {Messages_PullInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_pull = /** @type {((inputs?: Messages_PullInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_PullInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_pull(inputs)
	return cs_messages_pull(inputs)
});